<template>
  <div>
    <!--<temp></temp>-->
    <section class="frankinForm">
      <form>
        <!--for debuging-->
        <form-step-1 v-if="currentStep == 1 || devEnv"></form-step-1>
        <form-step-2 v-if="currentStep == 2 || devEnv"></form-step-2>
        <form-step-3 v-if="currentStep == 3 || devEnv"></form-step-3>
        <div class="frankinForm__separator"></div>
      </form>
    </section>

  </div>
</template>

<style lang="scss">
input.invalid {
  border: 1px solid #ff6267 !important;
}
.dg-main-content {
  margin-top:30px;
  border: .625rem solid #D55051;
  background-color: #E87B7B !important;
  padding: 15px;
  color: #fff;
  font-size: 1.125rem;
  font-weight: 700;
  position: relative;
  .dg-content-body {
    text-align: center;
    padding-bottom: 30px;
    span {
      position: relative;
      padding-top: 50px;
      line-height:1.4;
      display:block
    }
    span:before {
      background: url(/static/img/warning.7635896.png) !important;
      content: "";
      position: absolute;
      left: calc(50% - 23px);
      top: 15px;
      transform:translateY(-50%);
      width: 3.875rem;
      height: 3.875rem;
      background-size: contain;
    }
  }
  .dg-content-footer {
    text-align: center;
    .dg-btn {
      width: 100%;
    }
    .dg-btn--cancel {
      background-color: #d55051;
    }
    .dg-btn--ok {
      color: #d55051;
      border-color: #d55051;
      margin-top: 15px;
    }
    .dg-pull-right {
      float: none !important;
    }
  }

}
</style>

<script>
  import FormStep1 from './Form/Step-1/Form.vue'
  import FormStep2 from './Form/Step-2/Form.vue'
  import FormStep3 from './Form/Step-3/Form.vue'
  import ErrorModal from './Form/ErrorModal.vue'
  import Temp from './Temp.vue'
  import {mapState, mapMutations} from 'vuex'

  export default {
    data() {
      return {
        showWarning: false,
        to: null,
        warnMessage: '<span>Stop! Pressing the back button will return you to themailingexpert.com home page. To go back a step use the "< back" button located at the bottom of the page. <br><br> Don\'t forget you can always retrieve your quote with your unique ID and email address</span>',
        options: {
          okText: 'Don\'t leave this page',
          cancelText: 'Go back to Home Page',
          html: true
        }
      }
    },
    beforeRouteLeave (to, from, next) {
      if (this.currentStep !== 1 && to.name !== 'results.index') {
        this.$dialog
          .confirm(this.warnMessage, this.options)
          .then(() => {
            next(false)
          })
          .catch(() => {
            next()
          })
      } else {
        next()
      }

    },
    created() {
      if (!this.$route.query.dont_reset) {
        this.resetStep1()
        this.resetStep2()
        this.resetStep3()
      }
      document.body.classList.remove('has-table')

      if (this.$route.query.form === 'callback') {
        this.updateStep1({ machines_amount: 2 })
        this.updateFormData({ machines: 2 })
      }
    },
    computed: {
      ...mapState('QuoteForm', ['currentStep']),
      devEnv() {
        return false
      }
    },
    components: {
      'temp': Temp,
      'form-step-1': FormStep1,
      'form-step-2': FormStep2,
      'form-step-3': FormStep3,
      'error-modal': ErrorModal
    },
    methods: {
      ...mapMutations('QuoteForm', ['resetStep1', 'resetStep2', 'resetStep3', 'stepBack', 'updateStep1', 'updateFormData']),
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Quotes/Create.vue